import React from 'react';
import { RenderModule } from 'holocron';
import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { usePersonaArticles } from '../../hooks/usePersonaApi';
import { PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME } from '../../constants/modules';

const ForYou = () => {
  const {
    heading,
    articles,
    personaType,
    isLoading: personaLoading,
  } = usePersonaArticles();
  const locale = useSelector(getActiveLocaleSelector);

  const [, market] = locale.toLowerCase().split('-');
  const analyticsElementPrefix = `${market}hp-foryou-${personaType}`;

  return (
    <div data-testid="axp-travel-home-just-for-you" className="pad-4-b pad-t-xs-down">
      <RenderModule
        moduleName={PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME}
        props={{
          heading,
          articles,
          analyticsElementPrefix,
          isParentDataLoading: personaLoading,
        }}
      />
    </div>
  );
};

export default ForYou;
